/**
 * GET/PATCH /projects/:id/settings — normalize `{ general, notification }` for UI.
 */

export const DEFAULT_PROJECT_SETTINGS = {
  general: {
    project_status: "active",
    visibility: "org",
  },
  notification: {
    notifications_enabled: true,
    notify_on_issue_assigned: true,
    notify_on_status_changed: true,
    notify_on_comment_added: true,
  },
};

/**
 * @param {unknown} raw — API body (often `{ success, data: { general, notification } }`)
 */
export function parseProjectSettingsResponse(raw) {
  const inner = raw?.data?.data ?? raw?.data ?? raw;
  if (!inner || typeof inner !== "object") {
    return { ...DEFAULT_PROJECT_SETTINGS };
  }
  const g = inner.general && typeof inner.general === "object" ? inner.general : {};
  const n = inner.notification && typeof inner.notification === "object" ? inner.notification : {};
  return {
    general: {
      project_status: g.project_status ?? DEFAULT_PROJECT_SETTINGS.general.project_status,
      visibility: g.visibility ?? DEFAULT_PROJECT_SETTINGS.general.visibility,
    },
    notification: {
      notifications_enabled:
        n.notifications_enabled !== undefined
          ? Boolean(n.notifications_enabled)
          : DEFAULT_PROJECT_SETTINGS.notification.notifications_enabled,
      notify_on_issue_assigned:
        n.notify_on_issue_assigned !== undefined
          ? Boolean(n.notify_on_issue_assigned)
          : DEFAULT_PROJECT_SETTINGS.notification.notify_on_issue_assigned,
      notify_on_status_changed:
        n.notify_on_status_changed !== undefined
          ? Boolean(n.notify_on_status_changed)
          : DEFAULT_PROJECT_SETTINGS.notification.notify_on_status_changed,
      notify_on_comment_added:
        n.notify_on_comment_added !== undefined
          ? Boolean(n.notify_on_comment_added)
          : DEFAULT_PROJECT_SETTINGS.notification.notify_on_comment_added,
    },
  };
}
